import React, { useEffect, useState } from "react";
import "./index.less";
import { Button, InputNumber, message, Modal, Space } from "antd";

import { LightningAddOrShowFavouritesEnum, LightningSearchTypeEnum, LightningTabsEnum, LightningTabsEnumArray } from "@/util/cosntants";
import IF from "@/components/IF";
import {
    LightningCloseSvg,
    LightningDrawOnMapIcon,
    LightningLocationIcon,
    LightningRegionsIcon,
    LightningHideForMobileIcon,
    LightningShowforMobileIcon,
    LightningLeftMenuBar
} from "@/resource/IconComponents";
import cehub from "@/resource/images/png/CEhub.png";
// selef defined component
import LightningGoogleMap from "./components/LightningGoogleMap/LightningGoogleMap";
import LightningLocation from "./components/LightningLocation/LightningLocation";
import LightningRegion from "./components/LightningRegion/LightningRegion";
import LightningFavouritesModal from "./components/FavouritesModal/FavouritesModal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/reducer/store";
import { sagaActionTypes,
    updateAddOrShowFavouritesModel,
    updateAuthorCode,
    updateCommonErrorMessage,
    updateCommonSuccessMessage,
    updateCommonWarnMessage,
    updateCountriesTreeData,
    updateCurrentTab,
    updateDetectedRadius,
    updateIsClickedSearchResultButton,
    updateIsGetAllUSAData,
    updateIsLoadingForGetSearchResult,
    updateIsRefresh,
    updateIsResetContentForCurrentTabChange,
    updateIsResetMapContentBeforeSearch,
    updateSearchReuslt,
    updateTolerance,
    updateWindowWidth} from "@/redux/actions/lightningAction";
import star from "@/resource/images/png/lightning/star.png";
import { CloseOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import INFO_ICON from "@/resource/images/png/lightning/Info_Icon.svg";
import { IGetCountriesTreeResModel } from "@/util/http/Lightning/responseType";
import localforage from "localforage";
import LightningDrawOnMap from "./components/LightningDrawOnMap";
import { IGetLightningTypeContoursReqModel } from "@/util/http/Lightning/requestType";
import { getLightningTypeContours } from "@/util/http/Lightning";
import { blockForOneSecond } from "./lightningCommonFunc";
import CurrentUTCTime from "./components/CurrentUTCTime/CurrentUTCTime";

const LightningComponent = () => {

    const dispatch = useDispatch();
    const currentTab = useSelector((state: RootState) => state.lightningReducer.currentTab);
    const errorMessage = useSelector((state: RootState) => state.lightningReducer.errorMessage);
    const successMessage = useSelector((state: RootState) => state.lightningReducer.successMessage);
    const warningMessage = useSelector((state: RootState) => state.lightningReducer.warningMessage);
    const searchType = useSelector((state: RootState) => state.lightningReducer.searchType);
    const isGetAllUSAData = useSelector((state: RootState) => state.lightningReducer.isGetAllUSAData);
    const isFresh = useSelector((state: RootState) => state.lightningReducer.isFresh);
    //从redux中拿取每个tab的输入值
    const locationNameOrCoordinate = useSelector((state: RootState) => state.lightningReducer.locationNameOrCoordinate);
    const radiusValue = useSelector((state: RootState) => state.lightningReducer.radiusValue);
    const selectedLocationItem = useSelector((state: RootState) => state.lightningReducer.selectedLocationItem);
    const expandedKeys = useSelector((state: RootState) => state.lightningReducer.expandedKeys);
    const selectedKeys = useSelector((state: RootState) => state.lightningReducer.selectedKeys);
    const checkedKeys = useSelector((state: RootState) => state.lightningReducer.checkedKeys);
    const autoExpandParent = useSelector((state: RootState) => state.lightningReducer.autoExpandParent);
    const drawnShape = useSelector((state: RootState) => state.lightningReducer.drawnShape);
    const detectedRadius = useSelector((state: RootState) => state.lightningReducer.detectedRadius);
    const tolerance = useSelector((state: RootState) => state.lightningReducer.tolerance);

    const [messageApi, contextHolder] = message.useMessage();
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isCollapsedPC, setIsCollapsedPC] = useState(false);
    const [noticeVisible, setNoticeVisible] = useState<boolean>(true);
    // get entire usa data

    const publicHandelErrorMessage = ()=>{
        let tmpMessage = "";
        if(currentTab === LightningTabsEnum.LOCATION){
            switch (searchType) {
                case LightningSearchTypeEnum.FIRSTSTRIKE:
                    tmpMessage = "No  data for first strike for selected location/coordinate for next 1 hour.";
                    break;
                case LightningSearchTypeEnum.DETECTED:
                    tmpMessage = "No detected strike for selected location/coordinate.";
                    break;
                case LightningSearchTypeEnum.PROBABILITY:
                    tmpMessage = "No probability is determined for selected location/coordinate.";
                    break;
                case LightningSearchTypeEnum.ALLCLEAR:
                    tmpMessage = "No data for all clear tab for selected location/coordinate.";
                    break;
            }
        }
        else if(currentTab === LightningTabsEnum.Region || currentTab === LightningTabsEnum.DRAWONMAP){
            switch (searchType) {
                case LightningSearchTypeEnum.FIRSTSTRIKE:
                    tmpMessage = "No  data for first strike for selected region for next 1 hour.";
                    break;
                case LightningSearchTypeEnum.DETECTED:
                    tmpMessage = "No detected strike for selected region.";
                    break;
                case LightningSearchTypeEnum.PROBABILITY:
                    tmpMessage = "No probability is determined for selected region.";
                    break;
                case LightningSearchTypeEnum.ALLCLEAR:
                    tmpMessage = "No data for all clear tab for selected region.";
                    break;
            }

        }
        return tmpMessage;
    };


    const publicGetAllUSAData = async() => {
        const requestOptions:IGetLightningTypeContoursReqModel = {
            lightningType: searchType,
            isReplot: searchType === LightningSearchTypeEnum.DETECTED ? false : true, // 只有 DETECTED 需要 isReplot
        };

        // operation for add to Favourites
        try{
            dispatch(updateIsResetMapContentBeforeSearch(true));
            dispatch(updateSearchReuslt(null));
            // 等待一个微任务，确保重置逻辑完成
            await Promise.resolve();
            dispatch(updateIsLoadingForGetSearchResult(true));
            const res = await getLightningTypeContours(requestOptions);
            console.log("Search Result:", res?.data);
            if(res?.data && res?.data?.features){
                if(res.data.features.length > 0){
                    // dispatch(updateCommonSuccessMessage("Successfully get Risk data."));
                    await blockForOneSecond(); // 模拟阻塞1秒
                    dispatch(updateSearchReuslt(res?.data));
                }
                else{
                    dispatch(updateCommonSuccessMessage(publicHandelErrorMessage()));
                }
            }
        }
        catch (error) {
            console.error("Error fetching lightning type contours:", error);
            dispatch(updateCommonWarnMessage("Failed to get Risk data."));
        }
        finally{
            dispatch(updateIsLoadingForGetSearchResult(false));
        }
    };



    // init funct
    const initFunc = async()=>{
        // get country data
        const tmpCountryTreeDataItem = await localforage.getItem<string>("country");
        if(tmpCountryTreeDataItem){
            const countryTreeData = JSON.parse(tmpCountryTreeDataItem) as IGetCountriesTreeResModel[];
            dispatch(updateCountriesTreeData(countryTreeData));
        }
        else{
            dispatch({
                type: sagaActionTypes.SAGA_UPDATE_COUNTRESTREEDATA,
                payload: {
                    countries: "United States"
                }
            });
        }
        // get author code
        const tmpAuthorCode = localStorage.getItem("authorCode");
        if(tmpAuthorCode) {
            dispatch(updateAuthorCode(tmpAuthorCode));
        }
    };
    useEffect(() => {
        initFunc();
    }, []);
    useEffect(()=>{
        if(isGetAllUSAData && searchType){
            publicGetAllUSAData();
        }
    },[isGetAllUSAData,searchType]);

    const errorNotification = (message: string) => {
        Modal.error({
            title: "Error",
            content: message,
            className: "custom-modal-ok-button",// 应用自定义样式类名
        });
    };

    const warningNotification = (message: string) => {
        Modal.warning({
            title: "Warning",
            content: message,
            className: "custom-modal-ok-button",// 应用自定义样式类名
        });
    };
    const successNotification = (message: string) => {
        Modal.success({
            title: "Success",
            content: message,
            className: "custom-modal-ok-button",// 应用自定义样式类名
        });
    };
    useEffect(() => {
        if (errorMessage) {
            errorNotification(errorMessage);
            dispatch(updateCommonErrorMessage(""));
        }
        if (warningMessage) {
            warningNotification(warningMessage);
            dispatch(updateCommonWarnMessage(""));
        }
        if (successMessage) {
            successNotification(successMessage);
            dispatch(updateCommonSuccessMessage(""));
        }
    }, [errorMessage, warningMessage, successMessage]);

    //for switch tab
    const { confirm } = Modal;
    const showChangeTabConfirm = (value) => {
        confirm({
            title: "Are you sure want to switch search type?",
            icon: <ExclamationCircleFilled />,
            content: "When change search types, all data will be clear.",
            className: "custom-modal-ok-button",
            onOk() {
                dispatch(updateIsGetAllUSAData(false));
                dispatch(updateCurrentTab(value));
                dispatch(updateIsResetContentForCurrentTabChange(true));
            },
            onCancel() {
                //nothing
            },
        });
    };

    //下面是获取窗口尺寸，并将其值更新到redux中
    const getWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    //get windowWidth
    const useWindowWidth = () => {
        const [width, setWidth] = useState(getWidth);

        useEffect(() => {
            const handleResize = () => {
                setWidth(getWidth());
            };

            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);

        return width;
    };
    const windowWidth = useWindowWidth();
    useEffect(()=>{
        dispatch(updateWindowWidth(windowWidth));
    },[windowWidth]);



    return (
        <div className="lightning-component"
            id="lightning-component"
        >
            {contextHolder}
            <div className="lightning-title-container">
                <div className="lightning-title">
                    <img src={cehub} width={120} height={40}></img>
                    <div>Greencast Lightning</div>
                </div>

                <CurrentUTCTime className="lighting-title-date"/>
            </div>
            <div className="bg-div">
                <div className={`lightning-${currentTab === LightningTabsEnum.DRAWONMAP ? "DrawOnMap" : currentTab}-all-container`}>
                    {/* show tabs */}
                    <div className="foldable-container"
                        style={{
                            ...(isCollapsedPC ? { width: "0" } : {}),
                            ...( (windowWidth < 768 && isCollapsed) ? { width: "0"} : {})
                        }}
                    >
                        {/* 折叠按钮 */}

                        {
                            windowWidth < 768 && (
                                <div className="fold-button">
                                    <button
                                        onClick={() => setIsCollapsed(!isCollapsed)}
                                    >
                                        <span className="icon">{isCollapsed ? <LightningShowforMobileIcon />: <LightningHideForMobileIcon />}</span>
                                    </button>
                                </div>
                            )
                        }

                        {/* 内容容器 */}
                        <div
                            className={`lightning-content-container ${isCollapsed ? "collapsed" : ""}`}
                            style={(isCollapsedPC && (currentTab === LightningTabsEnum.Region)) ? { display: "none" } : { display: "block" }}
                        >


                            <div className="lightning-content-tabs">

                                <div
                                    className="lightning-content-tabs-group"
                                >
                                    {
                                        LightningTabsEnumArray.map((item, index) => {
                                            const activeOrNotClass = item === currentTab ? "lightning-content-tab-item-active" : "lightning-content-tab-item-inactive";
                                            const iconColor = item === currentTab ? "#14803C" : "black";
                                            const handleTabClick = () => {
                                                console.log("6666region expandedKeys",expandedKeys);
                                                console.log("6666region selectedKeys",selectedKeys);
                                                console.log("6666region checkedKeys",checkedKeys);
                                                console.log("6666region autoExpandParent",autoExpandParent);
                                                // 检查 expandedKeys 是否存在且只包含 "United States"
                                                const isOnlyUS = Array.isArray(expandedKeys) && expandedKeys.length === 1 && expandedKeys[0] === "United States";
                                                if (item === currentTab) return;
                                                const shouldConfirm = () => {
                                                    switch (currentTab) {
                                                        case LightningTabsEnum.LOCATION:
                                                            return !!(locationNameOrCoordinate || (radiusValue!==10) || selectedLocationItem);
                                                        case LightningTabsEnum.Region:
                                                            return !!(!isOnlyUS || selectedKeys?.length || checkedKeys?.length || !autoExpandParent);
                                                        case LightningTabsEnum.DRAWONMAP:
                                                            return !!(drawnShape!==null);
                                                        default:
                                                            return false;
                                                    }
                                                };

                                                // 如果需要确认，则显示对话框，否则直接切换
                                                if (shouldConfirm()) {
                                                    showChangeTabConfirm(item);
                                                } else {
                                                    dispatch(updateIsGetAllUSAData(false));
                                                    dispatch(updateCurrentTab(item));
                                                    dispatch(updateIsResetContentForCurrentTabChange(true));
                                                }
                                            };
                                            return (
                                                <div className={`${activeOrNotClass} lightning-content-tab-item`} key={index}
                                                    onClick={handleTabClick}
                                                >
                                                    <div className="lightning-content-tab-item-icon">
                                                        <IF show={item === LightningTabsEnum.LOCATION}>
                                                            <LightningLocationIcon
                                                                color={iconColor}
                                                            />
                                                        </IF>
                                                        <IF show={item === LightningTabsEnum.Region}>
                                                            <LightningRegionsIcon
                                                                color={iconColor}
                                                            />
                                                        </IF>
                                                        <IF show={item === LightningTabsEnum.DRAWONMAP}>
                                                            <LightningDrawOnMapIcon
                                                                color={iconColor}
                                                            />
                                                        </IF>
                                                    </div>
                                                    <div className="lightning-content-tab-item-title">
                                                        {item}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>


                                <div
                                    className="lightning-content-tab-item lightning-content-tab-item-favourites"
                                    onClick={()=>{
                                        dispatch(updateAddOrShowFavouritesModel(LightningAddOrShowFavouritesEnum.SHOW));
                                    }}
                                >
                                    <img src={star} />
                                </div>
                            </div>
                            <IF show={currentTab === LightningTabsEnum.Region && windowWidth > 767}>
                                <div title="Expand / Collapse" style={{display:"flex",flexDirection:"row",alignItems:"end",padding:"10px 40px 0 0",cursor:"pointer"}}>
                                    <div style={{marginLeft:"auto"}}
                                        onClick={() => setIsCollapsedPC(!isCollapsedPC)}
                                    >
                                        <LightningCloseSvg />
                                    </div>
                                </div>
                            </IF>
                            <div className="lightning-content-tabs-content">
                                <IF show={currentTab === LightningTabsEnum.LOCATION}>
                                    <LightningLocation />
                                </IF>
                                <IF show={currentTab === LightningTabsEnum.Region}>
                                    <LightningRegion/>
                                </IF>
                                <IF show={currentTab === LightningTabsEnum.DRAWONMAP}>
                                    <LightningDrawOnMap/>
                                </IF>
                            </div>
                        </div>
                    </div>

                    {/* show Result, mean maps content */}
                    <div className="lightning-result-container"
                        style={(isCollapsedPC && (currentTab === LightningTabsEnum.Region)) ? { width: "100%",marginLeft:"25px",height:"600px" } : null}
                    >
                        {
                            (windowWidth >= 768 && (currentTab === LightningTabsEnum.Region)) && isCollapsedPC &&(
                                <button title="Expand / Collapse"
                                    style={{position:"absolute",left:"0px",backgroundColor:"#FFF",width:"35px",
                                        height:"35px",top:"120px",borderRadius:"4px",cursor:"pointer"}} className="region-expend-button"
                                    onClick={() => setIsCollapsedPC(!isCollapsedPC)}
                                >
                                    <span className="icon"><LightningLeftMenuBar /></span>
                                </button>
                            )
                        }
                        <LightningGoogleMap />
                    </div>
                </div>
            </div>
            <div className="lightning-bottom">
                <div>
                 © Powered by FLASH Weather AI
                </div>
                {/* <InputNumber
                        value={detectedRadius}
                        onChange={(value) => {
                            dispatch(updateDetectedRadius(value));
                        }}
                    />
                    <InputNumber
                        value={tolerance}
                        onChange={(value) => {
                            dispatch(updateTolerance(value));
                        }}
                    /> */}
                <div>
                   Terms & Conditions
                </div>
            </div>

            <LightningFavouritesModal/>

        </div>
    );
};

export default LightningComponent;